import { MDBAlert, MDBBtn, MDBIcon, MDBSpinner } from 'mdb-react-ui-kit';
import React, { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { deleteSharedVM } from '../../../apiclients/streamsapi_bridge';

const RemoveSharedVM = forwardRef((props, ref) => {
    const [internalError, setInternalError] = useState(false);
    const { t, i18n } = useTranslation();

    async function removeThisVM(e) {
        try {
            setInternalError(false);
            props.setIsloading(true);
            let deleteVMResponse = await deleteSharedVM(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                props.vmId
            );
            setTimeout(() => { props.setIsloading(false) }, 1000);
            let delInfo = await deleteVMResponse.json();

            if (delInfo.status == 'success') {
                localStorage.setItem("s_message", delInfo.message);
                props.onClose();
                window.location.href = "/vmlanding";
            } else {
                localStorage.setItem("f_message", delInfo.message);
                window.location.href = "/vmlanding";
            }
        } catch (e) {
            console.log(`Unable to process Request :Internal server Error:!`);
            setInternalError(true);
        }
    }

    return (
        <>
            {internalError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                >
                    Internal Server Error
                </MDBAlert>
            )}
            <div className="bg-danger bg-opacity-25 p-3 rounded-3 square border border-2 border-danger">
                {(props.assocCFData && props.assocCFData.length > 0) ? (
                    <>
                        {props.assocCFData && props.assocCFData.length > 0 && (
                            <div>
                                <span>{t("vm_associated_cflows")}<br />{props.assocCFData?.map(obj => (' ' + obj.name + ' : ' + obj.extension + ' ')).toString()}</span>
                            </div>
                        )}

                        <div style={{ display: "none" }}>
                            <button ref={ref} onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                props.onClose();
                            }}>
                                {t("okay")}
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="d-flex align-items-center">
                            <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                            <span>{t("RemoveSharedVMtxt")}</span>
                        </div>

                        <div style={{ display: "none" }}>
                            <button ref={ref} onClick={(e) => removeThisVM(e)}>
                                {t("remove")}
                            </button>
                        </div>
                    </>
                )}
            </div>
        </>
    );
});

export default RemoveSharedVM;
